module.exports = __webpack_public_path__ + "static/img/oceanSciencesNB.b79aca2.png";